var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4764 3.1665C16.4764 3.1665 13.1254 7.33317 9.00042 7.33317C4.87542 7.33317 1.52442 3.1665 1.52442 3.1665M4.16667 12.3332H13.8333C14.7667 12.3332 15.2335 12.3332 15.59 12.1515C15.9036 11.9918 16.1586 11.7368 16.3183 11.4232C16.5 11.0667 16.5 10.5999 16.5 9.6665V3.33317C16.5 2.39975 16.5 1.93304 16.3183 1.57652C16.1586 1.26291 15.9036 1.00795 15.59 0.848162C15.2335 0.666504 14.7667 0.666504 13.8333 0.666504H4.16667C3.23325 0.666504 2.76653 0.666504 2.41002 0.848162C2.09641 1.00795 1.84144 1.26291 1.68166 1.57652C1.5 1.93304 1.5 2.39975 1.5 3.33317V9.6665C1.5 10.5999 1.5 11.0667 1.68166 11.4232C1.84144 11.7368 2.09641 11.9918 2.41002 12.1515C2.76653 12.3332 3.23324 12.3332 4.16667 12.3332Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopClosed);
export default __webpack_public_path__ + "static/media/envelop_closed.47de095a3f5dffdd902bf24a4cab3e05.svg";
export { ForwardRef as ReactComponent };